import { render, staticRenderFns } from "./g-chapter.vue?vue&type=template&id=e698f94e&scoped=true"
import script from "./g-chapter.vue?vue&type=script&lang=js"
export * from "./g-chapter.vue?vue&type=script&lang=js"
import style0 from "./g-chapter.vue?vue&type=style&index=0&id=e698f94e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e698f94e",
  null
  
)

export default component.exports